gsap.registerPlugin(ScrollTrigger);

const lenis = new Lenis({
  duration: 1.8,
  smoothWheel: true,
  smoothTouch: false,
  easing: (t) => 1 - Math.pow(1 - t, 4)
});

function raf(time) {
  lenis.raf(time);
  requestAnimationFrame(raf);
}
requestAnimationFrame(raf);

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 1000);
});
gsap.ticker.lagSmoothing(0);

function splitTextToLetters(selectors) {
  document.querySelectorAll(selectors).forEach((el) => {
    if (el.classList.contains("is-splitted")) return;
    el.classList.add("is-splitted");

    const text = el.textContent.trim();
    el.textContent = "";

    text.split("").forEach((char) => {
      const span = document.createElement("span");
      span.className = "char";
      span.innerHTML = char === " " ? "&nbsp;" : char;
      el.appendChild(span);
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  splitTextToLetters(".banner__heading, .banner__text");

gsap.from(".banner__heading .char", {
  yPercent: 120,
  rotationX: 50,
  opacity: 0,
  transformPerspective: 700,
  duration: 0.9,
  ease: "expo.out",
  stagger: 0.05,
  scrollTrigger: {
    trigger: ".banner",
    start: "top 80%"
  }
});

gsap.from(".banner__text p .char", {
  yPercent: 150,
  rotationX: 35,
  opacity: 0,
  transformPerspective: 700,
  duration: 0.7,
  ease: "power3.out",
  stagger: 0.03,
  scrollTrigger: {
    trigger: ".banner__text",
    start: "top 85%"
  }
});

gsap.to(".banner", {
  backgroundPositionY: "30%",
  ease: "none",
  scrollTrigger: {
    trigger: ".banner",
    start: "top bottom",
    end: "bottom top",
    toggleActions: "play reverse play reverse"
  }
});


});

gsap.registerPlugin(ScrollTrigger);

const selectors = [
  ".gsap-text-animate",
  ".rich-text__heading"
];

document.querySelectorAll(selectors.join(",")).forEach(text => {

  gsap.fromTo(
    text,
    {
      opacity: 0.5,
      x: -60 
    },
    {
      scrollTrigger: {
        trigger: text,
        start: "top 85%",
        end: "top 10%",
        toggleActions: "play reverse play reverse"
      },
      opacity: 1,
      x: 0,
      duration: 0.8,
      ease: "power3.out"
    }
  );

});
